import React from 'react';
import { ProductType } from '@/@types';
import dynamic from 'next/dynamic';

const DetailsByType: {
  [type: string]: ReturnType<
    typeof dynamic<{
      product: any;
    }>
  >;
} = {
  default: dynamic(() => {
    return import('./components/default');
  }),
  restaurants: dynamic(() => {
    return import('./components/places');
  }),
  places: dynamic(() => {
    return import('./components/places');
  }),
};

const Details: React.FC<{ product: ProductType }> = ({ product }) => {
  const Component = DetailsByType[product.category.name] || DetailsByType.default;
  return (
    <section>
      <Component product={product} />
    </section>
  );
};

export default Details;
